/**
 * Canonical theme token keys (values live in skins/).
 * CSS variable: --rd-{kebab-case-key}
 *   primaryHover -> --rd-primary-hover
 *   chart1       -> --rd-chart-1
 */

export const TOKEN_KEYS = [
  // Brand
  'primary',
  'primaryHover',
  'primaryActive',
  'primaryContrast',
  'accent',

  // App chrome (AppBar, tab strip). Deliberately separate from `primary`:
  // the chrome is the largest surface in the app, so a skin must be able to
  // keep it neutral while `primary` stays the interactive accent.
  'chromeBg',
  'chromeFg',
  'chromeTabInactive',
  'chromeTabInactiveHover',
  'chromeSurface',

  // Surfaces / text / chrome
  'bgDefault',
  'bgPaper',
  'bgElevated',
  'bgSubtle',
  'bgDialogActions',
  // Input/field fill. Must stay distinguishable from bgPaper, otherwise fields
  // dissolve into the card they sit on.
  'bgField',
  'textPrimary',
  'textSecondary',
  'textDisabled',
  'divider',
  'border',

  // Feedback
  'error',
  'errorContrast',
  'warning',
  'success',
  'info',
  'danger',

  // Report status
  'statusNew',
  'statusNewFg',
  'statusStarted',
  'statusStartedFg',
  'statusAwaiting',
  'statusAwaitingFg',
  'statusApproved',
  'statusApprovedFg',
  'statusProvisionally',
  'statusProvisionallyFg',
  'statusRejected',
  'statusRejectedFg',
  'statusCorrection',
  'statusCorrectionFg',
  'statusCorrectionBorder',

  // Emergency / insurance
  'emergencyNormal',
  'emergencyNormalBg',
  'emergencyUrgent',
  'emergencyUrgentBg',
  'emergencyEmergency',
  'emergencyEmergencyBg',
  'insurance',
  'insuranceBg',

  // Calendar event types
  'calDuty',
  'calOncall',
  'calVacation',
  'calAbsence',
  'calTraining',
  'calBlocked',
  'calMaintenance',

  // Charts
  'chart1',
  'chart2',
  'chart3',
  'chart4',
  'chart5',
  'chart6',
  'chart7',
  'chart8',
  'chart9',
  'chart10',

  // Layout editor
  'rulerDark',
  'rulerLight',
  'rulerBg',
  'marginColor',
  'marginBg',
  'marginBorder',

  // Chat
  'chatGroup',
  'chatMale',
  'chatFemale',
  'chatGroupHover',
  'chatMaleHover',
  'chatFemaleHover',

  // Fields / tables
  'dbFieldBg',
  'scrollbarThumb',
  'datagridBg',
  'datagridHeader',

  // Demo-user avatars (App.js role colors)
  'demo1',
  'demo2',
  'demo3',
  'demo4',
  'demo5',
  'demo6',
  'demo7',
  'demo8',
];

export function toCssVar(key) {
  const kebab = key
    .replace(/([A-Z])/g, '-$1')
    .replace(/([a-zA-Z])(\d)/g, '$1-$2')
    .toLowerCase();
  return `--rd-${kebab}`;
}

/** CSS value: var(--rd-primary) */
export function tokenVar(key) {
  return `var(${toCssVar(key)})`;
}

export const LEGACY_ALIASES = {
  '--chart-color-1': '--rd-chart-1',
  '--chart-color-2': '--rd-chart-2',
  '--chart-color-3': '--rd-chart-3',
  '--chart-color-4': '--rd-chart-4',
  '--chart-color-5': '--rd-chart-5',
  '--chart-color-6': '--rd-chart-6',
  '--chart-color-7': '--rd-chart-7',
  '--chart-color-8': '--rd-chart-8',
  '--chart-color-9': '--rd-chart-9',
  '--chart-color-10': '--rd-chart-10',
  '--ruler-dark-color': '--rd-ruler-dark',
  '--ruler-light-color': '--rd-ruler-light',
  '--ruler-background': '--rd-ruler-bg',
  '--margin-color': '--rd-margin-color',
  '--margin-background': '--rd-margin-bg',
  '--margin-border': '--rd-margin-border',
  '--chat-group-color': '--rd-chat-group',
  '--chat-male-color': '--rd-chat-male',
  '--chat-female-color': '--rd-chat-female',
  '--chat-group-dark': '--rd-chat-group-hover',
  '--chat-male-dark': '--rd-chat-male-hover',
  '--chat-female-dark': '--rd-chat-female-hover',
};
